import React from 'react';
import Politicas from './PoliticasPrivacidade';
import Regulamento from './Regulamento';
import Termos from './TermosUso';
import Login from './ModalLogin';
import ImpactoAmbiental from './ImpactoAmbiental';
import ProdutosMaisSustentaveis from './ProdutosMaisSustentaveis';
import Diversidade from './Diversidade';
import TransformacaoSocial from './TransformacaoSocial';

const ModalConductor = props => {
  switch (props.currentModal) {
    case 'POLITICAS':
      return <Politicas {...props}/>;

    case 'REGULAMENTO':
      return <Regulamento {...props}/>;

    case 'TERMOS':
      return <Termos {...props}/>;

    case 'LOGIN':
      return <Login {...props}/>;

    case 'ImpactoAmbiental':
      return <ImpactoAmbiental {...props}/>;

    case 'ProdutosMaisSustentaveis':
      return <ProdutosMaisSustentaveis {...props}/>;

    case 'Diversidade':
      return <Diversidade {...props}/>;

    case 'TransformacaoSocial':
      return <TransformacaoSocial {...props}/>;

    default:
      return null;
  }
};

export default ModalConductor;



// WEBPACK FOOTER //
// ./src/components/ModalConductor.js